var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-title"},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('div',{staticClass:"close-panel"},[_vm._t("default")],2),_vm._v(" "),(!_vm.hideCloseButton)?_c('div',{staticClass:"close-panel",on:{"click":_vm.closePanel}},[_c('i',{staticClass:"fal fa-times close-icon"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df535da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ModalLayoutTop.vue
// module id = null
// module chunks = 